<template>
    <div class="card shadow">
        <div class="card-header">Received Files Summary</div>
        <div class="card-body p-0 d-flex flex-column">
            <ul class="file-list">
                <li v-for="file in files" v-bind:key="file.Id" class="py-2 px-3 m-0">
                    <span>{{file.Name}}</span>
                    <div class="d-flex align-items-center">
                        <span class="mx-1">{{file.FileType}}</span>
                        <span class="mx-1">{{file.Size}}</span>
                        <span class="mx-1 btn btn-sm" :class="{'btn-success': file.IsNew, 'btn-light' : !file.IsNew}">
                            <font-awesome-icon :icon="['fad', 'check']" fixed-width v-if="file.IsNew" />
                            <font-awesome-icon :icon="['fad', 'times']" fixed-width v-if="!file.IsNew" />
                        </span>
                        <span class="mx-1 btn btn-sm" :class="{'btn-success' : file.IsRead, 'btn-light' : !file.IsRead}">
                            <font-awesome-icon :icon="['fad', 'check']" fixed-width v-if="file.IsRead" />
                            <font-awesome-icon :icon="['fad', 'times']" fixed-width v-if="!file.IsRead" />
                        </span>
                        <span class="mx-1 btn btn-sm btn-primary">
                            <font-awesome-icon :icon="['fad', 'eye']" fixed-width />
                        </span>
                    </div>
                </li>
            </ul>
            <router-link to="/receivedfiles" class="btn btn-primary mb-3 mx-auto">Show All</router-link>
        </div>
    </div>
</template>
<script>
export default {
    name: 'received-files-panel',
    data () {
        return {
            files: [
                {
                    Id: 51518,
                    Name: 'Report.doc',
                    FileType: 'doc',
                    Size: '518618',
                    IsNew: false,
                    IsRead: false
                },
                {
                    Id: 51518,
                    Name: 'Speadsheet.xlsx',
                    FileType: 'xlsx',
                    Size: '985612',
                    IsNew: true,
                    IsRead: false
                },
                {
                    Id: 51518,
                    Name: 'Report.doc',
                    FileType: 'doc',
                    Size: '518618',
                    IsNew: false,
                    IsRead: false
                },
                {
                    Id: 51518,
                    Name: 'Report.doc',
                    FileType: 'doc',
                    Size: '518618',
                    IsNew: false,
                    IsRead: false
                },
                {
                    Id: 51518,
                    Name: 'Report.doc',
                    FileType: 'doc',
                    Size: '518618',
                    IsNew: false,
                    IsRead: false
                },
                {
                    Id: 51518,
                    Name: 'Report.doc',
                    FileType: 'doc',
                    Size: '518618',
                    IsNew: false,
                    IsRead: false
                }
            ]
        }
    }
}
</script>
<style scoped>
    .file-list {
        list-style-type: none;
        display: flex;
        flex-direction:column;
    }

    .file-list li {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 2px solid #f1f4f6;
    }
</style>


// WEBPACK FOOTER //
// src/components/user/received-files-panel.vue